export default __webpack_public_path__ + "static/media/FilledStar.eb868de8.svg";